import { CarSelectsValues } from './types';

export const defaultValues: CarSelectsValues = {
  brand: null,
  model: null,
  year: null,
};
